import { render } from "./IconSelect.vue?vue&type=template&id=e3c8f840&scoped=true"
import script from "./IconSelect.vue?vue&type=script&lang=js"
export * from "./IconSelect.vue?vue&type=script&lang=js"

import "./IconSelect.vue?vue&type=style&index=0&id=e3c8f840&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c8f840"]])

export default __exports__